import React, { useState, useEffect } from 'react';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Swal from 'sweetalert2';
import Mtn from '../assets/images/mtn.png';
import Airtel from '../assets/images/airtel.jpg';
import TopNav from './topNav';
import BottomNav from './bottomNav';
import Packages from '../assets/images/Packages.png'
import Momo from '../assets/images/PAYWITH MOMO.png'
const Deposit: React.FC = () => {
  const [transactionId, setTransactionId] = useState('');
  const [selectedAmount, setSelectedAmount] = useState<number | null>(null);
  const [userId, setUserId] = useState<string | null>(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);
      } else {
        Swal.fire('Error', 'User not authenticated', 'error');
      }
    });
    return () => unsubscribe();
  }, []);

  const handleSubmit = async () => {
    if (!transactionId || selectedAmount === null || !userId) {
      Swal.fire(
        'Error',
        'Please select an amount, enter a valid transaction ID, and make sure you are logged in.',
        'error'
      );
      return;
    }

    try {
      const userDoc = doc(db, 'users', userId);
      await updateDoc(userDoc, {
        deposit: {
          transactionId,
          amount: selectedAmount,
          date: serverTimestamp(),
        },
      });

      Swal.fire('Success', 'Transaction ID submitted successfully', 'success');
      setTransactionId('');
      setSelectedAmount(null);
    } catch (error) {
      console.error('Error submitting transaction:', error);
      Swal.fire('Error', 'Failed to submit transaction. Please try again.', 'error');
    }
  };

  return (
    <>
      <TopNav />
      <div className="bg-gray-900 p-8 rounded-lg shadow-lg max-w-md mx-auto mt-10 border border-gray-700">
      <div className="w-full max-w-screen-sm mx-auto p-4">
      <img
        src={Packages}
        alt="Placeholder Image"
        className="w-full h-auto rounded-lg shadow-lg"
      />
    </div>
        <h2 className="text-2xl font-bold mb-4 text-center text-white">Deposit via Mobile Money</h2>
        <p className="text-center text-gray-400 mb-6 text-sm">
          Select an amount and enter your transaction ID to make a deposit.
          Approval takes less than 30 minutes.
        </p>

        {/* Deposit Options */}
        <div className="w-full max-w-screen-sm mx-auto p-4">
      <img
        src={Momo}
        alt="Placeholder Image"
        className="w-full h-auto rounded-lg shadow-lg"
      />
    </div>
    <h2 className="text-2xl font-bold mb-4 text-center text-white">Tap To Select Amount You Deposited</h2>
        <div className="mb-4 flex justify-between">
          {[3500, 7000, 12000, 25000].map((amount) => (
            <button
              key={amount}
              onClick={() => setSelectedAmount(amount)}
              className={`py-2 px-4 rounded-md font-semibold text-white ${
                selectedAmount === amount ? 'bg-yellow-500' : 'bg-gray-700'
              }`}
            >
              UGX {amount.toLocaleString()}
            </button>
          ))}
        </div>

        {/* Transaction ID Input */}
        <div className="mb-4">
          <label htmlFor="transactionId" className="block text-sm font-medium text-gray-300 mb-1">
            Enter Your <b>VALID</b> Transaction ID
          </label>
          <input
            style={{ color: 'black', fontWeight: 'bold' }}
            type="text"
            id="transactionId"
            value={transactionId}
            onChange={(e) => setTransactionId(e.target.value)}
            className="w-full px-4 py-2 border border-gray-600 rounded-md focus:outline-none focus:border-yellow-500"
            placeholder="Transaction ID"
          />
        </div>

        {/* Submit and Clear Buttons */}
        <div className="flex justify-between mt-6">
          <button
            className="bg-gray-700 text-gray-300 font-semibold py-2 px-4 rounded-md"
            onClick={() => {
              setTransactionId('');
              setSelectedAmount(null);
            }}
          >
            Clear
          </button>
          <button
            onClick={handleSubmit}
            className="bg-yellow-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-yellow-600"
          >
            Submit
          </button>
        </div>

        <p className="mt-6 text-center text-gray-500 text-xs">
          Note: If you submit an incorrect Transaction ID, your payment will not be approved.
        </p>
      </div>
      <BottomNav />
    </>
  );
};

export default Deposit;
